interface ComputerWithCloudSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithCloudSVG = ({ color, style }: ComputerWithCloudSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="50"
    viewBox="0 0 45 50"
    fill="none"
  >
    <g clipPath="url(#clip0_465_6139)">
      <path
        d="M12.6551 25.0561C9.7073 25.0561 7.3186 22.6674 7.3186 19.7196C7.3186 16.7719 9.7073 14.3832 12.6551 14.3832C12.7262 14.3832 12.7872 14.3832 12.8583 14.3933C12.7465 13.8749 12.6855 13.3464 12.6855 12.7975C12.6855 8.69094 16.0196 5.35693 20.1261 5.35693C23.4703 5.35693 26.296 7.56267 27.2312 10.6019C28.0139 10.3275 28.8575 10.175 29.7317 10.175C33.8382 10.175 37.1722 13.509 37.1722 17.6155C37.1722 21.722 34.0923 24.8019 30.1993 25.0459H12.6551V25.0561Z"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9915 15.1965C19.2214 14.4037 20.6749 13.9463 22.2403 13.9463C23.8056 13.9463 25.2592 14.4139 26.4891 15.1965"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5122 17.5346C21.0103 17.2093 21.5998 17.0264 22.2402 17.0264C22.8806 17.0264 23.4701 17.2195 23.9682 17.5346"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.4233 20.2381C22.4233 20.1365 22.342 20.0552 22.2403 20.0552C22.1387 20.0552 22.0574 20.1365 22.0574 20.2381C22.0574 20.3398 22.1387 20.4211 22.2403 20.4211C22.342 20.4211 22.4233 20.3398 22.4233 20.2381Z"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.9664 0.569336H4.22844C2.49028 0.569336 1.07739 1.98222 1.07739 3.72038V28.8474C1.07739 30.5856 2.49028 31.9985 4.22844 31.9985H40.2622C42.0003 31.9985 43.4132 30.5856 43.4132 28.8474V3.72038C43.4132 1.98222 42.0003 0.569336 40.2622 0.569336H34.9664Z"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4453 31.9985L9.52417 36.8674H22.2402H34.9663L33.0452 31.9985"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.0487 40.5571L43.7283 47.2048C44.2772 48.201 43.5555 49.4309 42.4171 49.4309H2.07354C0.935096 49.4309 0.203241 48.201 0.762297 47.2048L4.44191 40.5571H40.0487Z"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_465_6139">
        <rect width="44.4907" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerWithCloudSVG;
